export enum Status {
  Draft = 1,
  Active = 2,
  Inactive = 3
}

export function getStatusName(status: Status): string {
  switch (status) {
    case Status.Draft:
      return 'Draft';
    case Status.Active:
      return 'Active';
    case Status.Inactive:
      return 'Inactive';
    default:
      return 'Unknown';
  }
}

export enum InventoryTypes {
  Movement = 1,
  Transfer = 2,
  Counting = 3
}

export function getInventoryTypesName(type: InventoryTypes): string {
  switch (type) {
    case InventoryTypes.Movement:
      return 'Movement';
    case InventoryTypes.Transfer:
      return 'Transfer';
    case InventoryTypes.Counting:
      return 'Counting';
    default:
      return 'Unknown';
  }
}
export enum Apps {
  Unknown = 0,
  TPMPortal = 1,
  POS = 2,
  Donation = 3,
  Lister = 4,
  AdminPortal = 5,
  CompanyPortal = 6,
  IMS = 7
}

export enum LicenseStatus {
  Unknown = 0,
  Available = 1,
  Assigned = 2,
  Expired = 3,
  NotFound = 4
}

export enum MovementItemsStatus {
  Draft = 1,
  ReadyForMovement = 2,
  InProgress = 3,
  Completed = 4,
  Cancelled = 5
}
export enum RootCompany {
  RootCompanyId = -1
}

export enum OverrideStatus {
  Unknown = 0,
  Active = 1,
  Inactive = 2
}
export enum PricingType {
  GbbCategorySubCategory = 1,
  PriceListCategorySubCategory = 2,
  PriceListDepartment = 3,
  QualityConditionCategorySubCategory = 4,
  GbbDepartment = 5,
  QualityConditionDepartment = 6
}

export enum OverrideType {
  Unknown = 0,
  WeeklySchedule = 1,
  DateSpecific = 2
}

export enum PrinterType {
  Unknown = 0,
  ZebraLabel = 1,
  ZebraTag = 2,
  ZebraBoth = 3
}

export enum ContainerStatus {
  Unknown = 0,
  InUse = 1,
  Available = 2
}
export enum ContainerType {
  Unknown = 0,
  Production = 1,
  Sorting = 2,
  Warehouse = 3,
  Transfer = 4,
  Salvage = 5
}
